// extracted by mini-css-extract-plugin
export default {"section":"Section_section__8lvP2","sectionTitle":"Section_sectionTitle__ERHXq","cardGrid":"Section_cardGrid__VHaPe"};